/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import SecondaryToolbar from 'shared/ui/components/form-components/SecondaryToolbar.vue';
import TabbedViews from 'shared/ui/components/TabbedViews.vue';
import General from 'ui/components/wizards/create-webinar-template/General.vue';
import WebinarTemplateDesign from 'ui/components/wizards/create-webinar-template/Design.vue';
import WebinarTemplateRegistration from 'ui/components/wizards/create-webinar-template/Registration.vue';
import WebinarTemplateIntegrations from 'ui/components/wizards/create-webinar-template/Integrations.vue';
// import WebinarTemplatePostEvent from './create-webinar-template/PostEvent.vue';

// Utils
import { get } from 'lodash';

// Model
import WebinarTemplate from 'libs/models/webinar/webinar-template';

const __vue_script__ = {
    name: 'WebinarTemplateEditor',

    components: {
        SecondaryToolbar,
        TabbedViews,
        General,
        WebinarTemplateDesign,
        WebinarTemplateRegistration,
        WebinarTemplateIntegrations,
    },

    data() {
        const user = this.$services.user.getCurrentUser();

        return {
            loading: true,
            canCreate: user.orgs.some(org => this.$services.user.hasPermission('templates.create_new', { org_id: org._id })),
            error: null,
            viewTemplate: new WebinarTemplate({ name: '' }),
            gettingStartedUrl: this.$utils.links.getLinkUrl('cms_template'),
            template: undefined,
            views: [
                {
                    title: 'wizards.create_webinar_template.step_1_title',
                    component: General,
                },
                {
                    title: 'wizards.create_webinar_template.step_2_title',
                    component: WebinarTemplateDesign,
                    classes: { design: true }
                },
                {
                    title: 'wizards.create_webinar_template.step_3_title',
                    component: WebinarTemplateRegistration,
                }
                // TODO: uncomment when integrations are implemented
                // {
                //     title: 'wizards.create_webinar_template.step_4_title',
                //     component: WebinarTemplateIntegrations,
                // }
            ]
        };
    },

    computed: {
        /** @returns {boolean} */
        noResults() {
            return !this.template;
        },

        /** @returns {boolean} */
        noDataAfterLoading() {
            return !this.template && !this.loading;
        }
    },

    async created() {
        const templateId = (this.$router.getRouteParams() || {}).templateId;
        const templateDocument = await this.getTemplate(templateId);

        if (!templateDocument) {
            this.loading = false;
            this.$router.push(this.$const.ROUTE_WEBINAR_TEMPLATE_LIST);
            return;
        }

        const templateModel = new WebinarTemplate(templateDocument);
        const template = { ...templateModel };
        const getUrl = this.$utils.assets.getWebinarTemplateAssetPath.bind(null, template._id);

        ['background', 'icon', 'banner'].forEach((imgName) => {
            const hasAttachment = Boolean(templateModel[imgName]);
            if (hasAttachment) {
                template[imgName] = [getUrl(imgName)];
            }
        });

        this.viewTemplate = template || this.viewTemplate;
        this.loading = false;
    },

    methods: {
        /**
         * Returns the template from the backend.
         *
         * @param {string} routeTemplateId the template id
         */
        async getTemplate(routeTemplateId) {
            if (!routeTemplateId) return;

            const templateId = this.template && this.template._id;

            if (routeTemplateId === templateId) return; // still editing the same one

            try {
                const user = this.$services.user.getCurrentUser();
                const orgId = this.$services.org.getFirstRelevantOrg(user);
                this.template = await this.$services.webinar.getTemplate(orgId, routeTemplateId);
            } catch (error) {
                this.error = get(error, 'response.data.error') || error.message;
            }

            return this.template;
        },

        /**
         * PUT the edited template to backend
         */
        async submit() {
            const form = await this.$refs.tabbedViewForm.getValidatedForm();

            if (!form) return; // TODO: handle submit validation errors more gracefully

            const user = this.$services.user.getCurrentUser();
            const orgId = this.$services.org.getFirstRelevantOrg(user);
            await this.$services.webinar.updateTemplate(form, orgId);
            this.$nextTick(() => this.$router.push('/webinars/templates'));
        }

    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loader',{staticClass:"inner-page webinar-template-editor",attrs:{"status":_vm.loading}},[_c('section',{staticClass:"page-content"},[_c('header',{staticClass:"template-name"},[_c('h1',[_vm._v(_vm._s((_vm.viewTemplate.name || '')))])]),(_vm.noDataAfterLoading)?_c('div',{staticClass:"no-data"},[_c('h1',{staticClass:"welcome"},[_vm._v(_vm._s(_vm.$t('templates.welcome')))]),_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.$t("templates.no_template_edit")))]),_c('a',{attrs:{"href":_vm.gettingStartedUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('templates.learn_more')))])]):[(!_vm.loading && !_vm.error)?_c('tabbed-views',{ref:"tabbedViewForm",attrs:{"initial-data":_vm.viewTemplate,"views":_vm.views}}):_vm._e(),_c('secondary-toolbar',[_c('button',{staticClass:"btn primary",on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t('general.save')))])])]],2)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "WebinarTemplateEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__